module.exports = __webpack_public_path__ + "img/culturacorporativa.1945bee4.png";